import BlackBird from 'shared/blackbird'

export function useGetWebhookEventId() {
  const query = BlackBird.getQuery<{ id?: string }>()
  const webhookEventId = query.id

  return {
    webhookEventId
  }
}
